export default __webpack_public_path__ + "static/media/sidebar-16.bcc05dc9.png";